import { Action } from '@ngrx/store'
import * as MemberActions from '../../modules/member/member.actions'

export const CTA_AAA = () => $localize`Please call AAA for additional assistance:`
export const CTA_RAP = () => $localize`Please try again or contact support for assistance:`

export const getMemberNoMatchesMessage = (isRap = false): string =>
  `${ERROR_RETRIEVE_MEMBER(isRap)} ${isRap ? CTA_RAP() : CTA_AAA()}`

export const ERROR_RETRIEVE_MEMBER = (isRap = false) => isRap ?
  $localize`An error occurred while trying to retrieve your information.` :
  $localize`An error occurred while trying to retrieve your member information.`

const ERROR_ADD_VEHICLE = () => $localize`An error occurred while trying to add a new vehicle to your account.`
const ERROR_REMOVE_VEHICLE = () => $localize`An error occurred while trying to remove this vehicle.`
const ERROR_LOAD_VEHICLES = () => $localize`An error occurred while trying to load the information for your vehicles.`
const ERROR_UPDATE_VEHICLE = () => $localize`An error occurred while trying to update your vehicle's information.`

const buildErrorMessage = (error: string, isRap: boolean): string =>
  `<p>${error}<br/>${isRap ? CTA_RAP() : CTA_AAA()}</p>`

// TODO remove
export function getActionErrorMessage(action: Action, isRap = false): string | null {
  if (action.type === MemberActions.MEMBER_INFO.FAILURE) {
    return buildErrorMessage(ERROR_RETRIEVE_MEMBER(isRap), isRap)
  }
  if (action.type === MemberActions.VEHICLE_ADD.FAILURE) {
    return buildErrorMessage(ERROR_ADD_VEHICLE(), isRap)
  }
  if (action.type === MemberActions.VEHICLE_DELETE.FAILURE) {
    return buildErrorMessage(ERROR_REMOVE_VEHICLE(), isRap)
  }
  if (action.type === MemberActions.VEHICLE_LOAD.FAILURE) {
    return buildErrorMessage(ERROR_LOAD_VEHICLES(), isRap)
  }
  if (action.type === MemberActions.VEHICLE_UPDATE.FAILURE) {
    return buildErrorMessage(ERROR_UPDATE_VEHICLE(), isRap)
  }
  return null
}
